export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': '应用',
            'horizontal': '横',
            'horizontalMenu': '水平的菜单',
            'general': '一般',
            'component': '零件',
            'features': '特征',
            'applications': '应用',
            'dashboard': '仪表板',
            'dashboard1': '仪表板 1',
            'dashboard2': '仪表板 2',
            'dashboard3': '仪表板 3',
            'modules': '模块',
            'agency': '机构',
            'pages': '网页',
            'gallery': '画廊',
            'pricing': '价钱',
            'terms&Conditions': '条款条件',
            'feedback': '反馈',
            'report': '报告',
            'faq(s)': 'FAQ（S',
            'advancedComponent': '高级组件',
            'blank': '空白',
            'session': '会议',
            'login': '登录',
            'register': '寄存器',
            'lockScreen': '锁屏',
            'forgotPassword': '忘记密码',
            'uiComponents': 'UI组件',
            'alerts': '警报',
            'appBar': '应用程序栏',
            'avatars': '头像',
            'buttons': '纽扣',
            'bottomNavigations': '底部导航',
            'badges': '徽章',
            'cards': '牌',
            'cardsMasonry': '卡砌体',
            'chip': '芯片',
            'dialog': '对话',
            'dividers': '分频器',
            'drawers': '抽屉',
            'popover': '酥料饼',
            'expansionPanel': '扩展面板',
            'gridList': '网格列表',
            'list': '名单',
            'menu': '菜单',
            'popoverAndToolTip': '流行和工具提示',
            'progress': '進展',
            'snackbar': '小吃店',
            'selectionControls': '選擇控件',
            'advanceUiComponents': '提前UI組件',
            'dateAndTimePicker': '日期和時間選擇器',
            'tabs': '標籤',
            'stepper': '步進',
            'notification': '通知',
            'sweetAlert': '甜蜜警報',
            'autoComplete': '自動完成',
            'aboutUs': '關於我們',
            'widgets': '小工具',
            'forms': '形式',
            'formElements': '表單元素',
            'textField': '文本域',
            'selectList': '選擇列表',
            'charts': '圖表',
            'reCharts': '重新圖表',
            'reactChartjs2': '应对 图表 Js 2',
            'icons': '圖標',
            'themifyIcons': 'Themify圖標',
            'simpleLineIcons': '簡單的線圖標',
            'fontAwesome': '字體真棒',
            'materialIcons': '材料圖標',
            'tables': '表',
            'basic': '基本',
            'dataTable': '數據表',
            'responsive': '響應',
            'reactTable': '反應表',
            'maps': '地圖',
            'googleMaps': '谷歌地圖',
            'leafletMaps': '傳單地圖',
            'inbox': '收件箱',
            'users': '用戶',
            'userProfile1': '用户配置文件1',
            'userProfile2': '用户配置文件2',
            'userManagement': '用户管理',
            'userProfile': '用戶資料',
            'userList': '用戶列表',
            'calendar': '日历',
            'cultures': '文化',
            'dnd': 'DND',
            'selectable': '可選',
            'customRendering': '自定義渲染',
            'chat': '聊',
            'toDo': '去做',
            'editor': '編輯',
            'wysiwygEditor': '所見即所得的編輯器',
            'quillEditor': '羽毛編輯器',
            'reactAce': '应对 高手',
            'dragAndDrop': '拖放',
            'reactDragula': '反應Dragula',
            'reactDnd': '反應Dnd',
            'blogManagement': '博客管理',
            'ecommerce': '電子商務',
            'shopList': '商店列表',
            'shopGrid': '車間網格',
            'invoice': '發票',
            'multilevel': '多級',
            'sublevel': '綜',
            'dateTimePicker': '日期和时间选择器',
            'user': '用户',
            'miscellaneous': '杂',
            'promo': '促销',
            'gettingStarted': '入门',
            'shop': '店',
            'cart': '大车',
            'checkout': '查看',
            'saas': 'SAAS',
            'multiLevel': '多级',
            'level1': '1级',
            'level2': '2级',
            'boxed': '盒装',
            'news': '新闻',
            'extensions': '扩展',
            'imageCropper': '图像裁剪器',
            'videoPlayer': '视频播放器',
            'dropzone': '拖放区',
            'crm': 'CRM',
            'projects': '项目',
            'projectDetail': '项目细节',
            'clients': '客户',
            'reports': '报告'
        },
        'widgets': {
            'totalEarns': '贏得總額',
            'emailsStatistics': '電子郵件統計',
            'totalRevenue': '總收入',
            'onlineVistors': '在線訪問者',
            'trafficSources': '流量來源',
            'RecentOrders': '最近的訂單',
            'topSellings': '暢銷產品',
            'productReports': '產品報告',
            'productStats': '產品統計',
            'ComposeEmail': '寫郵件',
            'employeePayroll': '員工工資',
            'visitors': '遊客',
            'orders': '命令',
            'orderStatus': '訂單狀態',
            'totalSales': '總銷售額',
            'netProfit': '淨利',
            'overallTrafficStatus': '總體交通狀況',
            'tax': '稅',
            'expenses': '筆開支',
            'currentTime': '当前时间',
            'currentDate': '当前日期',
            'todayOrders': '今日订单',
            'toDoList': '要做列表',
            'discoverPeople': '發現人',
            'commments': '註釋',
            'newCustomers': '新客戶',
            'recentNotifications': '近期通知',
            'appNotifications': '应用程序提醒',
            'newEmails': '新電子郵件',
            'siteVisitors': '網站訪問者',
            'socialCompanines': '社会公司',
            'recentActivities': '近期活動',
            'recentOrders': '最近的訂單',
            'gallery': '畫廊',
            'pricing': '價錢',
            'enterpriseEdition': '企業版',
            'personalEdition': '個人版',
            'teamEdition': '團隊版',
            'standard': '標準',
            'advanced': '高級',
            'master': '主',
            'Mega': '兆豐',
            'logIn': '登錄',
            'signUp': '註冊',
            'lockScreen': '鎖屏',
            'alertsWithLink': '警報與鏈接',
            'additionalContent': '其他內容',
            'alertDismiss': '警報關閉',
            'uncontrolledDisableAlerts': '不受控制的警報',
            'contexualAlerts': '同性戀警報',
            'ratings': '评级',
            'alertsWithIcons': '與圖標的警報',
            'Simple App Bars': '簡單的應用程序',
            'appBarsWithButtons': '與按鈕的應用酒吧',
            'imageAvatars': '圖像頭像',
            'lettersAvatars': '字母頭像',
            'iconsAvatars': '圖標頭像',
            'flatButtons': '平的按鈕',
            'raisedButton': '凸起的按鈕',
            'buttonWithIconAndLabel': '有像和標籤的按鈕',
            'floatingActionButtons': '浮動動作按鈕',
            'iconButton': '圖標按鈕',
            'socialMediaButton': '社交媒體按鈕',
            'reactButton': '反應按鈕',
            'buttonOutline': '按鈕輪廓',
            'buttonSize': '按鈕大小',
            'buttonState': '按鈕狀態',
            'buttonNavigationWithNoLabel': '沒有標籤的按鈕導航',
            'buttonNavigation': '按鈕導航',
            'iconNavigation': '圖標導航',
            'badgeWithHeadings': '與標題的徽章',
            'contexualVariations': '同性戀變異',
            'badgeLinks': '徽章鏈接',
            'materialBadge': '物質徽章',
            'simpleCards': '簡單的卡片',
            'backgroundVarient': '背景變化',
            'cardOutline': '卡大綱',
            'overlayCard': '覆蓋卡',
            'cardGroup': '卡組',
            'cardTitle': '卡標題',
            'speacialTitleTreatment': '特殊標題治療',
            'chipWithClickEvent': '芯片與點擊事件',
            'chipArray': '芯片陣列',
            'dialogs': '對話框',
            'listDividers': '列出分隔線',
            'insetDividers': '插入分隔線',
            'temporaryDrawers': '臨時抽屜',
            'permanentDrawers': '永久性抽屜',
            'simpleExpansionPanel': '簡單的擴展面板',
            'controlledAccordion': '受控手風琴',
            'secondaryHeadingAndColumns': '次級標題和列',
            'imageOnlyGridLists': '僅圖像網格列表',
            'advancedGridLists': '高級網格列表',
            'singleLineGridLists': '單線網格列表',
            'simpleLists': '簡單列表',
            'folderLists': '文件夾列表',
            'listItemWithImage': '列出具有圖像的項目',
            'switchLists': '切換列表',
            'insetLists': '插入列表',
            'nestedLists': '嵌套列表',
            'checkboxListControl': '複選框列表控件',
            'pinedSubHeader': '釘住小標題',
            'InteractiveLists': '交互式列表',
            'simpleMenus': '簡單的菜單',
            'selectedMenu': '選定的菜單',
            'maxHeightMenu': '最大高度菜單',
            'changeTransition': '改變轉變',
            'paper': '紙',
            'anchorPlayGround': '錨播放地面',
            'tooltip': '工具提示',
            'positionedToolTips': '定位小吃店',
            'circularProgressBottomStart': '圓形進展底部開始',
            'interactiveIntegration': '交互式集成',
            'determinate': '確定的',
            'linearProgressLineBar': '線性進度線條',
            'indeterminate': '不定',
            'buffer': '緩衝',
            'query': '詢問',
            'transitionControlDirection': '過渡控制方向',
            'simpleSnackbar': '簡單的小吃店',
            'positionedSnackbar': '定位小吃店',
            'contexualColoredSnackbars': '同性色彩的小吃店',
            'simpleCheckbox': '簡單的複選框',
            'interminateSelection': '中斷選擇',
            'disabledCheckbox': '已禁用複選框',
            'customColorCheckbox': '自定義顏色複選框',
            'VerticalStyleCheckbox': '垂直樣式複選框',
            'horizontalStyleCheckbox': '水平樣式複選框',
            'radioButtons': '單選按鈕',
            'disabledRadio': '殘疾人電台',
            'withError': '有錯誤',
            'switches': 'Swiches',
            'dateAndTimePicker': '日期和時間選擇器',
            'defaultPicker': '默認選取器',
            'timePicker': '時間選擇器',
            'weekPicker': '每週選擇器',
            'defaultDatePicker': '默認日期選取器',
            'customPicker': '自定義選取器',
            'tabs': '標籤',
            'fixedTabs': '固定標籤',
            'basicTab': '基本選項卡',
            'wrappedLabels': '包裝的標籤',
            'centeredLabels': '居中標籤',
            'forcedScrolledButtons': '強制滾動按鈕',
            'iconsTabs': '圖標選項卡',
            'withDisableTabs': '禁用選項卡',
            'iconWithLabel': '與標籤的圖標',
            'stepper': '步進',
            'horizontalLinear': '水平線性',
            'horizontalNonLinear': '水平非線性',
            'horizontalLinerAlternativeLabel': '水平的班輪替代標籤',
            'horizontalNonLinerAlternativeLabel': '水平無襯墊替代標籤',
            'verticalStepper': '垂直步進器',
            'descriptionAlert': '說明警報',
            'customIconAlert': '自定義圖標警報',
            'withHtmlAlert': '隨著Html 警报',
            'promptAlert': '提示警報',
            'passwordPromptAlert': '密碼提示警報',
            'customStyleAlert': '自定義樣式警報',
            'autoComplete': '自動完成',
            'reactSelect': '反應選擇',
            'downshiftAutoComplete': '降檔自動完成',
            'reactAutoSuggests': '反應自動建議',
            'aboutUs': '關於我們',
            'ourVission': '我們的願景',
            'ourMissions': '我們的使命',
            'ourMotivation': '我們的動機',
            'defualtReactForm': '默认 应对 形成',
            'url': '網址',
            'textArea': '文本區域',
            'file': '文件',
            'formGrid': '表格網格',
            'inlineForm': '內聯表格',
            'inputSizing': '輸入大小',
            'inputGridSizing': '輸入網格大小',
            'hiddenLabels': '隱藏標籤',
            'formValidation': '表單驗證',
            'number': '數',
            'date': '日期',
            'time': '時間',
            'color': '顏色',
            'search': '搜索',
            'selectMultiple': '選擇多個',
            'inputWithSuccess': '輸入與成功',
            'inputWithDanger': '危險輸入',
            'simpleTextField': '簡單的文本字段',
            'componet': '組件',
            'layouts': '佈局',
            'inputAdorements': '輸入戴首饰',
            'formattedInputs': '格式化輸入',
            'simpleSelect': '簡單的選擇',
            'nativeSelect': '本地選擇',
            'mutltiSelectList': '多選擇列表',
            'lineChart': '折線圖',
            'barChart': '條形圖',
            'stackedBarChart': '堆積的條形圖',
            'lineBarAreaChart': '線條區域圖',
            'areaChart': '面積圖',
            'stackedAreaChart': '堆積面積圖',
            'verticalChart': '垂直圖表',
            'radarChart': '雷達圖',
            'doughnut': '甜甜圈',
            'polarChart': '極坐標圖',
            'pieChart': '餅形圖',
            'bubbleChart': '泡沫圖',
            'horizontalBar': '單槓',
            'basicTable': '基本表',
            'contexualColoredTable': '同性色的桌子',
            'dataTable': '數據表',
            'employeeList': '員工名單',
            'responsiveTable': '響應表',
            'responsiveFlipTable': '響應翻轉表',
            'reactGridControlledStateMode': '反應網格控制狀態模式',
            'googleMaps': '谷歌地圖',
            'productsReports': '產品報告',
            'taskList': '任務列表',
            'basicCalender': '基本日曆',
            'culturesCalender': '文化日曆',
            'dragAndDropCalender': '拖放日曆',
            'selectableCalender': '可選日曆',
            'customRendering': '自定義渲染',
            'customCalender': '自定義日曆',
            'searchMailList': '搜索郵件列表',
            'forgetPassword': '忘記密碼',
            'QuickLinks': '快速链接',
            'upgrade': '升级',
            'app': '应用',
            'addNew': '添新',
            'orderDate': '订购日期',
            'status': '状态',
            'trackingNumber': '追踪号码',
            'action': '行动',
            'designation': '指定',
            'subject': '学科',
            'send': '发送',
            'saveAsDrafts': '另存为草稿',
            'onlineSources': '在线来源',
            'lastMonth': '上个月',
            'widgets': '小工具',
            'listing': '清单',
            'paid': '付费',
            'refunded': '退款',
            'done': '完成',
            'pending': '有待',
            'cancelled': '取消',
            'approve': '批准',
            'following': '以下',
            'follow': '跟随',
            'graphs&Charts': '图表和图表',
            'open': '打开',
            'bounced': '退回',
            'spam': '垃圾邮件',
            'unset': '取消设置',
            'bandwidthUse': '带宽使用',
            'dataUse': '数据使用',
            'unsubscribe': '退订',
            'profile': '轮廓',
            'messages': '消息',
            'support': '支持',
            'faq(s)': 'FAQ（S）',
            'upgradePlains': '升级平原',
            'logOut': '登出',
            'mail': '邮件',
            'adminTheme': '管理主题',
            'wordpressTheme': 'WordPress的主题',
            'addToCart': '添加到购物车',
            'plan': '计划',
            'basic': '基本',
            'pro': '临',
            'startToBasic': '开始到基本',
            'upgradeToPro': '升级到专业版',
            'upgradeToAdvance': '升级提前',
            'comparePlans': '比较计划',
            'free': '自由',
            'frequentlyAskedQuestions': '经常问的问题',
            'searchIdeas': '搜索想法',
            'startDate': '开始日期',
            'endDate': '结束日期',
            'cateogary': '类别',
            'apply': '应用',
            'downloadPdfReport': '下载PDF报告',
            'yesterday': '昨天',
            'totalOrders': '总订单',
            'totalVisitors': '总访问者数',
            'typeYourQuestions': '输入您的问题',
            'username': '用户名',
            'password': '密码',
            'signIn': '签到',
            'enterYourPassword': '输入您的密码',
            'alreadyHavingAccountLogin': '已经有帐户登录',
            'composeMail': '编写邮件',
            'issue': '问题',
            'recentChat': '最近聊天',
            'previousChat': '以前的聊天',
            'all': '所有',
            'filters': '过滤器',
            'deleted': '删除',
            'starred': '主演',
            'frontend': '前端',
            'backend': '后端',
            'api': 'API',
            'simpleAppBar': '简单的应用栏',
            'recents': '近期]',
            'cardLink': '卡链接',
            'anotherLink': '另一个链接',
            'cardSubtitle': '卡片副标题',
            'confirmationDialogs': '确认对话框',
            'deletableChip': '可删除芯片',
            'customDeleteIconChip': '自定义删除图标芯片',
            'openAlertDialog': '打开警报对话框',
            'openResponsiveDialog': '打开响应对话框',
            'openSimpleDialog': '打开简单对话框',
            'openFormDialog': '打开表单对话框',
            'follower': '信徒',
            'important': '重要',
            'private': '私人的',
            'openLeft': '打开 剩下',
            'openRight': '开放权利',
            'openTop': '打开顶端',
            'openBottom': '打开底部',
            'selectTripDestination': '选择旅程目的地',
            'pinnedSubheaderList': '固定的副标题列表',
            'singleLineItem': '单行项目',
            'acceptTerms': '接受条款',
            'optionA': '选项A',
            'optionB': '选项B.',
            'optionC': '选项C',
            'optionM': '选项M',
            'optionN': '选项N',
            'optionO': '选项O',
            'customColor': '自定义颜色',
            'centeredTabs': '居中的选项卡',
            'multipleTabs': '多个选项卡',
            'preventScrolledButtons': '防止滚动按钮',
            'browse': '浏览',
            'formValidate': '表单验证',
            'code': '码',
            'company': '公司',
            'price': '价钱',
            'change': '更改',
            'high': '高',
            'low': '低',
            'volume': '卷',
            'personalDetails': '个人资料',
            'occupation': '占用',
            'companyName': '公司名',
            'phoneNo': '电话号码',
            'city': '市',
            'zipCode': '邮政编码',
            'updateProfile': '更新个人信息',
            'reject': '拒绝',
            'exportToExcel': '导出到高强',
            'addNewUser': '添加新用户',
            'workWeek': '工作周',
            'agenda': '议程',
            'conference': '会议',
            'multilevel': '多级',
            'dailySales': '每日销售',
            'today': '今天',
            'campaignPerformance': '广告系列效果',
            'supportRequest': '支持请求',
            'usersList': '用户列表',
            'lastWeek': '上个星期',
            'buyMore': '买多点',
            'trafficChannel': '交通频道',
            'stockExchange': '股票交易',
            'tweets': '推文',
            'ourLocations': '我们的地点',
            'sales': '销售',
            'to': '至',
            'shipTo': '运送到',
            'description': '描述',
            'unitPrice': '单价',
            'total': '总',
            'note': '注意',
            'chipWithAvatar': '与具体化的芯片',
            'chipWithTextAvatar': '与文本具体化的芯片',
            'chipWithIconAvatar': '与象具体化的芯片',
            'customClickableChip': '自定义可点击芯片',
            'outlineChip': '大纲芯片',
            'disableChip': '禁用芯片',
            'alertDialog': '警报对话框',
            'animatedSlideDialogs': '动画幻灯片对话框',
            'fullScreenDialogs': '全屏对话框',
            'formDialogs': '表单对话框',
            'simpleDialogs': '简单的对话框',
            'responsiveFullScreen': '响应式全屏',
            'primary': '主',
            'social': '社会',
            'user': '用户',
            'admin': '管理员',
            'permanentdrawer': '永久性抽屉',
            'persistentdrawer': '持久的抽屉',
            'swiches': 'Swiches',
            'horizontalLinearAlternativeLabel': '水平线性替代标签',
            'horizontalNonLinearAlternativeLabel': '水平非线性替代标签',
            'notifications': '通知',
            'basicAlert': '基本警报',
            'successAlert': '成功警报',
            'warningAlert': '警告警报',
            'reactAutoSuggest': '反应自动建议',
            'components': '组件',
            'inputAdornments': '输入',
            'multiSelectList': '多选列表',
            'contextualColoredTable': '同性色的桌子',
            'responsiveFilpTable': '响应翻动表',
            'updateYourEmailAddress': '更新电子邮件地址',
            'selectADefaultAddress': '选择一个默认地址',
            'activity': '活动',
            'basicCalendar': '基本日历',
            'culturesCalendar': '文化日历',
            'dragAndDropCalendar': '拖放日历',
            'quillEditor': '羽毛编辑器',
            'reactDND': '反应DND',
            'dragula': 'Dragula',
            'AcceptorrRejectWithin': '接受或拒绝',
            'quoteOfTheDay': '今日报价',
            'updated10Minago': '10分钟前更新',
            'personalSchedule': '个人时间表',
            'activeUsers': '活跃用户',
            'totalRequest': '总请求',
            'new': '新',
            'ShareWithFriends': '和朋友分享！',
            'helpToShareText': '通过与社交媒体上的朋友和追随者分享我们的网站，帮助我们传播世界！',
            'thisWeek': '本星期',
            'howWouldYouRateUs': '你如何评价我们？',
            'booking': '预订',
            'confirmed': '确认',
            'monthly': '每月一次',
            'weekly': '每周',
            'target': '目标',
            'totalActiveUsers': '总活跃用户数',
            'deadline': '截止日期',
            'team': '球队',
            'projectManagement': '项目管理',
            'latestPost': '最新的帖子',
            'projectTaskManagement': '项目任务管理',
            'selectProject': '选择项目',
            'activityBoard': '活动委员会',
            'checklist': '清单',
            'baseConfig': '基本配置',
            'customControlBar': '自定义控制栏',
            'withDownloadButton': '使用下载按钮',
            'httpLiveStreaming': 'HTTP直播',
            'keyboardShortcuts': 'Keyboard Shortcuts',
            'preview': '预习',
            'croppedImage': '裁剪图像',
            'transactionList': '交易清单',
            'transferReport': '转移报告',
            'expenseCategory': '费用类别',
            'upcomingEvents': '接下来的活动',
            'OngoingProjects': '正在进行的项目',
            'ProjectStatus': '项目状态',
            'LiveChatSupport': '实时聊天支持'
        },
        'components': {
            'buyNow': '立即購買',
            'alreadyHavingAccountSignIn': '已經有帳戶登錄',
            'enterYourPassword': '輸入您的密碼',
            'unlock': '開鎖',
            'enterPasswords': '輸入密碼',
            'resestPassword': '重設密碼',
            'pageNotfound': '找不到網頁',
            'goToHomePage': '去首頁',
            'sorryServerGoesWrong': '抱歉服務器出錯了',
            'persistentDrawer': '持久的抽屜',
            'back': '背部',
            'next': '下一個',
            'completeStep': '完成一步',
            'withHtml': '與Html',
            'prompt': '提示',
            'withDescription': '帶說明',
            'success': '成功',
            'passwordPrompt': '密碼提示',
            'warning': '警告',
            'customIcon': '自定義圖標',
            'customStyle': '自定義樣式',
            'basic': '基本',
            'submit': '提交',
            'compose': '撰寫',
            'sendMessage': '發信息',
            'addNewTasks': '添加新任務',
            'addToCart': '添加到購物車',
            'payNow': '現在付款',
            'print': '打印',
            'cart': '大车',
            'viewCart': '查看购物车',
            'checkout': '查看',
            'summary': '概要',
            'yesterday': '昨天',
            'last7Days': '过去7天',
            'last1Month': '最近1个月',
            'last6Month': '过去6个月',
            'spaceUsed': '使用的空间',
            'followers': '信徒',
            'trending': '趋势',
            'paid': '付费',
            'refunded': '退款',
            'done': '完成',
            'pending': '有待',
            'cancelled': '取消',
            'approve': '批准',
            'week': '周',
            'month': '月',
            'year': '年',
            'today': '今天',
            'popularity': '声望',
            'email': '电子邮件',
            'drafts': '草稿',
            'sent': '发送',
            'trash': '垃圾',
            'all': '所有',
            'do': '做',
            'title': '标题',
            'projectName': '项目名',
            'companyName': '公司名',
            'openAlert': '打开警报',
            'slideInAlertDialog': '在警报对话框中滑动',
            'openFullScreenDialog': '打开全屏对话框',
            'basicChip': '基本芯片',
            'clickableChip': '可点击芯片',
            'left': '剩下',
            'right': '对',
            'expansionPanel1': '扩展面板1',
            'expansionPanel2': '扩展面板2',
            'generalSetting': '通用设置',
            'advancedSettings': '高级设置',
            'firstName': '名字',
            'lastName': '姓',
            'occupation': '占用',
            'phoneNo': '电话号码',
            'address': '地址',
            'city': '市',
            'state': '州',
            'zipCode': '邮政编码',
            'social Connection': '社交联系',
            'emailPrefrences': '电子邮件偏好',
            'myProfile': '我的简历',
            'product': '产品',
            'quantity': '数量',
            'totalPrice': '总价格',
            'removeProduct': '删除产品',
            'mobileNumber': '手机号码',
            'address2Optional': '地址2（可选）',
            'country': '国家',
            'zip': '压缩',
            'saveContinue': '保存并继续',
            'placeOrder': '下订单',
            'payment': '付款',
            'billingAddress': '帐单地址',
            'ShippingAddressText': '送货地址与帐单地址相同。',
            'CartEmptyText': '你的购物车是空的！',
            'NoItemFound': '未找到任何项目',
            'goToShop': '去商店',
            'cardNumber': '卡号',
            'expiryDate': '到期日',
            'cvv': 'CVV',
            'nameOnCard': '卡片上的名字',
            'confirmPayment': '确认付款'
        },
        'compenets': {
            'choose': '選擇',
            'username': '用戶名',
            'passwords': '密碼',
            'signIn': '簽到',
            'dontHaveAccountSignUp': '不要有帳戶註冊',
            'enterUserName': '輸入用戶名',
            'enterEmailAddress': '請輸入電郵地址',
            'confirmPasswords': '確認密碼'
        },
        'themeOptions': {
            'sidebarOverlay': '边栏覆盖',
            'sidebarBackgroundImages': '侧栏背景图片',
            'sidebarImage': '侧栏图像',
            'miniSidebar': '迷你边栏',
            'boxLayout': '箱子布局',
            'rtlLayout': 'Rtl布局',
            'darkMode': '黑暗模式',
            'appSettings': '应用设置',
            'sidebarLight': '光',
            'sidebarDark': '黑暗',
            'themeColor': '主题颜色'
        },
        'button': {
            'cancel': '取消',
            'add': '加',
            'update': '更新',
            'reply': '回复',
            'delete': '删除',
            'yes': '是',
            'viewAll': '查看全部',
            'like': '喜欢',
            'assignNow': '立即分配',
            'seeInsights': '见见解',
            'acceptTerms': '接受条款',
            'reject': '拒绝',
            'addNew': '添新',
            'goToCampaign': '转到广告系列',
            'viewProfile': '查看资料',
            'sendMessage': '发信息',
            'saveNow': '现在保存',
            'pen': '钢笔',
            'search': '搜索',
            'downloadPdfReport': '下载PDF报告',
            'primary': '主',
            'secondary': '次要',
            'danger': '危险',
            'info': '信息',
            'success': '成功',
            'warning': '警告',
            'link': 'Link',
            'smallButton': '小按钮',
            'largeButton': '大按钮',
            'blockLevelButton': '块级别按钮',
            'primaryButton': '主要按钮',
            'button': '按键',
            'save': '保存',
            'openMenu': '打开菜单',
            'openWithFadeTransition': '打开淡入淡出过渡',
            'openPopover': '打开酥料饼',
            'accept': '接受',
            'click': '点击',
            'complete': '完成',
            'back': '背部',
            'next': '下一个',
            'completeStep': '完成一步',
            'error': '错误',
            'writeNewMessage': '写新消息',
            'saveChanges': '保存更改',
            'addNewUser': '添加新用户',
            'more': '更多',
            'useDefaultImage': '使用默认图像',
            'cropImage': '裁剪图像'
        },
        'hint': {
            'whatAreYouLookingFor': '后端你在找什么',
            'searchMailList': '搜索邮件列表'
        },
        'module': {
            'inbox': '收件箱',
            'drafts': '草稿',
            'sent': '发送',
            'trash': '垃圾',
            'spam': '垃圾邮件',
            'frontend': '前端',
            'backend': '后端',
            'api': 'Api',
            'issue': '问题'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {}
    }
};
